import { useMemo } from 'react';
import { PaperProps } from '@mui/material';
import { useScheduledActionInvoiceQuery } from '../../../../api/gql';
import { ScheduledActionsTable } from '../../../../modules/admin/invoice/ScheduledActionsTable';

type Props = {
  taskId: string;
} & PaperProps;

export const TaskIdScheduledActionsBox = ({ taskId, ...rest }: Props) => {
  const { data, isLoading, isError } = useScheduledActionInvoiceQuery({
    id: taskId,
  });

  const scheduledActions = useMemo(
    () => data?.scheduledAction.invoice.scheduledActions,
    [data?.scheduledAction.invoice.scheduledActions],
  );

  return (
    <ScheduledActionsTable scheduledActions={scheduledActions} isLoading={isLoading} isError={isError} {...rest} />
  );
};
